/**
 * Shared mobile/tablet detection. Used by dashboard tabs, campaign-table, segments-table, etc.
 */
export function getIsMobileOrTablet(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  const isSmallScreen = window.matchMedia('(max-width: 1024px)').matches;
  const isTouchWithSmallScreen =
    ('ontouchstart' in window || navigator.maxTouchPoints > 0) && isSmallScreen;
  const hasMobileUA = mobileRegex.test(userAgent);
  return hasMobileUA || isTouchWithSmallScreen;
}
